var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.722 9.822h2.614v1.356h.037c.363-.66 1.254-1.356 2.58-1.356 2.759 0 3.268 1.738 3.268 3.997v4.603h-2.723v-4.08c0-.974-.02-2.225-1.418-2.225-1.419 0-1.635 1.06-1.635 2.154v4.15h-2.723V9.821zM6 9.822h2.835v8.6H6v-8.6zm2.835-2.388c0 .284-.084.56-.24.796a1.42 1.42 0 01-.635.528 1.402 1.402 0 01-1.544-.31 1.439 1.439 0 01-.308-1.562 1.43 1.43 0 01.522-.644 1.405 1.405 0 011.79.177 1.434 1.434 0 01.415 1.015z","fill":"#000"}));
}

LinkedinInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0  24 24"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
